export enum Permission {
  Private = 0,
  Fleet = 1,
  Client = 2,
}
